import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { preloadPageTitleContentProperties } from '@confluence/content-topper/entry-points/preloadPageTitleContentProperties.ts';
import { preloadArchivedPageBannerV2Queries } from '@confluence/archive-pages/entry-points/preloadArchivedPageBannerV2Queries.ts';

export function preloadContentTitleWithByLine(contentId: string, spaceKey: string) {
	return waitForAllReturnWhenError([
		preloadPageTitleContentProperties({ contentId, spaceKey }),
		preloadArchivedPageBannerV2Queries(contentId),
	]);
}
